import { Row, Col } from "antd";
import { BadgeHelp, Phone, Smartphone, Mail } from "lucide-react";
import DataGroup from "../../DataGroup";
import DataItem from "../../DataItem";

export default function PSSection(props) {
  const { verification, setVerification, hidden, loading } = props;

  const responsiveInfo = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 8,
  };

  return (
    <Col {...responsiveInfo}>
      <DataGroup
        title={
          !verification?.NombreCompletoPS ? "Persona que solicita la verificación" : `SOLICITA: ${verification?.NombreCompletoPS}`
        }
        subtitle={
          verification?.TipoPersonaPS_T && verification?.NacionalidadPS_T
            ? "Persona " + verification?.TipoPersonaPS_T + ", " + verification?.NacionalidadPS_T
            : null
        }
        formName={"Persona que solicita la verificación"}
        mainData={verification}
        setMainData={setVerification}
        verification={verification}
      >
        <DataItem
          icon={<BadgeHelp size={16} />}
          iconColor="brown"
          keyName={verification?.TipoDatoPS_T ? verification?.TipoDatoPS_T : "Tipo de identificación"}
          value={verification?.DatoPS_T}
          valueType="string"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<Phone size={16} />}
          iconColor="#1890ff"
          keyName="Teléfono fijo"
          value={verification?.TelefonoFijoPS_T}
          valueType="phone"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<Smartphone size={16} />}
          iconColor="indigo"
          keyName="Teléfono móvil"
          value={verification?.TelefonoMovilPS_T}
          valueType="phone"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<Mail size={16} />}
          iconColor="#1890ff"
          keyName="Correo electrónico"
          value={verification?.CorreoElectronicoPS_T}
          valueType="email"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
      </DataGroup>
    </Col>
  );
}